import type React from "react";

import { TooltipSurface } from "@/design-system/TooltipSurface";

export function ChartTooltip({ children }: { children: React.ReactNode }): React.ReactNode {
  return <TooltipSurface>{children}</TooltipSurface>;
}
